var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 27.7207V26.0332C21.875 23.9942 24.0927 22.0655 25.5313 20.6895C27.5591 18.751 28.625 16.1466 28.625 13.0957C28.625 7.47074 24.144 2.97074 18.5 2.97074C17.1694 2.96703 15.8511 3.22639 14.621 3.7339C13.3909 4.24142 12.2732 4.98708 11.3323 5.92801C10.3914 6.86894 9.64571 7.98659 9.1382 9.21668C8.63068 10.4468 8.37133 11.7651 8.37504 13.0957C8.37504 16.0376 9.48668 18.8185 11.4688 20.6895C12.8996 22.0402 15.125 23.9731 15.125 26.0332V27.7207M16.25 34.4707H20.75M15.125 31.0957H21.875M18.5 27.7207V18.7207",
    stroke: "#07839C",
    strokeOpacity: 0.4,
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1719 17.5957C21.1719 17.5957 19.6595 18.7207 18.5 18.7207C17.3405 18.7207 15.8281 17.5957 15.8281 17.5957",
    stroke: "#07839C",
    strokeOpacity: 0.4,
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.5233d15f20d588a070b4d71c407ee9f3.svg";
export { ForwardRef as ReactComponent };